module.exports = __webpack_public_path__ + "static/media/testfiles_entitySegmentation.5fdd6fdf.zip";